import { useId } from 'react';
import classNames from 'classnames';

import { RadioFilledAltIcon, RadioFilledIcon, RadioIcon } from '../../icons';

import styles from './_index.module.scss';

export interface RadioProps {
  'aria-label'?: string;
  isChecked?: boolean;
  isInverseColor?: boolean;
  label?: React.ReactNode;
  name?: string;
  onChange?: (value: any) => void;
  value: any;
}

const Radio = ({
  'aria-label': ariaLabel,
  isChecked,
  isInverseColor = false,
  label,
  name,
  onChange = () => {},
  value,
}: RadioProps) => {
  const id = useId();
  const labelId = useId();

  const handleChange = () => {
    onChange(value);
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      handleChange();
    }
  };

  const renderRadioIcon = () => {
    if (isInverseColor && isChecked) return <RadioFilledAltIcon />;
    if (isChecked) return <RadioFilledIcon />;
    return <RadioIcon />;
  };

  return (
    <div
      className={classNames(styles['radio'], { [styles['is-checked']]: isChecked })}
      data-checked={isChecked}
    >
      <input
        aria-hidden="true"
        checked={isChecked}
        id={id}
        name={name}
        onChange={handleChange}
        type="radio"
      />
      <div className={styles['radio-label']} id={labelId} onClick={handleChange}>
        <div
          aria-checked={Boolean(isChecked)}
          aria-label={ariaLabel}
          aria-labelledby={ariaLabel ? undefined : labelId}
          className={styles['radio-icon']}
          onKeyDown={handleKeyDown}
          role="radio"
          tabIndex={0}
        >
          {renderRadioIcon()}
        </div>
        {label}
      </div>
    </div>
  );
};

export default Radio;
